/* OFFLINE — interacciones propias. Sin librerías externas. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Eventos de analítica (solo se envían si hay consentimiento) ---------- */
  window.ofTrack = function (name, data) {
    try {
      document.dispatchEvent(new CustomEvent('of:track', { detail: { name: name, data: data || {} } }));
    } catch (e) {}
  };

  /* ---------- Añadir al carrito (tarjetas, upsell, botón fijo) ---------- */
  function openDrawerWith(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
      drawer.classList.remove('is-empty');
      return true;
    }
    return false;
  }

  async function addToCart(variantId, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }], sections: 'cart-drawer,cart-icon-bubble' }),
      });
      var data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'error');
      var item = data.items && data.items[0];
      window.ofTrack('add_to_cart', item ? { id: item.product_id, variant: item.variant_id, name: item.product_title, price: item.final_price / 100, qty: item.quantity } : {});
      if (!openDrawerWith({ id: item && item.id, sections: data.sections })) {
        window.location.href = root + 'cart';
      }
    } catch (err) {
      window.location.href = root + 'cart';
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-of-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn.getAttribute('data-of-add'), 1, btn);
  });

  /* ---------- Aparición suave al hacer scroll ---------- */
  var reveals = document.querySelectorAll('.of-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Botón fijo de compra en móvil ---------- */
  var sticky = document.querySelector('[data-of-sticky]');
  if (sticky) {
    var mainForm = document.querySelector('product-form, .product-form');
    var toggle = function (show) { sticky.classList.toggle('is-visible', show); };
    if (mainForm && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        toggle(!en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(mainForm);
    }
    var stickyBtn = sticky.querySelector('[data-of-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var idInput = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
        var qtyInput = document.querySelector('.product-form__quantity input[name="quantity"], input[name="quantity"]');
        var id = (idInput && idInput.value) || stickyBtn.getAttribute('data-variant');
        addToCart(id, qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1, stickyBtn);
      });
    }
  }

  /* ---------- Carrusel de reseñas: flechas ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-of-prev], [data-of-next]');
    if (!b) return;
    var sec = b.closest('section');
    var track = sec && sec.querySelector('[data-of-track]');
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: b.hasAttribute('data-of-prev') ? -step : step, behavior: 'smooth' });
  });

  /* ---------- Reseñas: ver más / ver menos ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-of-more]');
    if (!b) return;
    var sec = b.closest('section');
    var track = sec && sec.querySelector('[data-of-track]');
    if (!track) return;
    var open = track.classList.toggle('is-expanded');
    b.textContent = open ? b.getAttribute('data-less') : b.getAttribute('data-more');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Eventos de vista ---------- */
  var pageData = document.getElementById('of-page-data');
  if (pageData) {
    try {
      var pd = JSON.parse(pageData.textContent);
      if (pd.type === 'product') window.ofTrack('view_item', pd.product);
      if (pd.type === 'cart') window.ofTrack('view_cart', pd.cart);
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('#CartDrawer-Checkout, [name="checkout"], a[href$="/checkout"]')) window.ofTrack('begin_checkout', {});
    if (e.target.closest('#cart-icon-bubble')) window.ofTrack('view_cart', {});
  });
})();
